const collectSteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>In the Collect Overview, you can view the list of users to whom the survey has been sent..</h2>,
      placement: "bottom",
      target: "#collectLeftMenuOverview",
      title: "First step",
      scrollTo: false,
    },
    {
      content: <h2>With the options in the Recipient Lists, you can add new users to your survey.</h2>,
      placement: "left",
      target: "#collectLeftMenuRecipients",
      title: "Fourth step",
      scrollTo: false,
    },
    {
      content: <h2>In the Collect Email Template, you can customize the email template that will be used to send the survey to users.</h2>,
      placement: "bottom",
      target: "#collectLeftMenuEmailTemplate",
      title: "Third step",
      scrollTo: false,
    },
    {
      content: <h2>With the Collect Schedule, you can customize the date the email will be sent and specify the start and end dates for the survey.</h2>,
      placement: "bottom",
      target: "#collectLeftMenuSchedule",
      title: "Fourth step",
      scrollTo: false,
    },
  ]
  export default collectSteps;